<template v-if="!loading">
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <preview-popup
        :preview-data="previewData"
        :is-advertising-banner="true"
        :show-preview="preview"
        @hide-preview="hidePreview"
    />
    <broadcast-search
        v-model="entity.action_id"
        @broadcast-search-names="broadcastNames = arguments[0]"
        ref="broadcastsearchref"
        :multiple=false
    />
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a class="btn btn_action btn_grey btn_preview"
             :title="'Náhled' | translate"
             @click.stop="showPreview"
             v-translate>Náhled</a>
          <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs">
        <ul class="tabs">
          <li :class="{'r-tabs-state-active' : this.$route.name === 'advertisingBannerDetail'}"><a
              @click.stop="openRoute('advertisingBannerDetail')" v-translate>Vlastnosti</a></li>
          <li v-if="entity" :class="{'r-tabs-state-active' : this.$route.name === 'advertisingBannerDetailRecipients'}"><a
              @click.stop="openRoute('advertisingBannerDetailRecipients')" v-translate>Příjemci</a></li>
        </ul>

        <keep-alive>
          <router-view
              :entity="entity"
              :messageEntity="entity"
              :isEditable="isEditable"
              :isUpdate="isUpdate"
              :ref="$route.name"
              :broadcast-names="broadcastNames"
              @broadcast-search-modal="$refs.broadcastsearchref.showModal(true, arguments[0])"
              @broadcast-search-input="$refs.broadcastsearchref.selected = arguments[0]"
              @selectedLanguageChange="onSelectedLanguageChange"
          />
        </keep-alive>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
              <input
                  v-if="isEditable"
                  type="submit"
                  :value="'Uložit' | translate"
                  class="btn"
                  @click.prevent.stop="updateAdvertisingBanner">
            </p>
          </section>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "../../mixins/detail-actions";
import entity from "./mixins/entity";
import PreviewPopup from "../messages/popup/PreviewPopup.vue";
import BroadcastSearch from "../../common/BroadcastSearch.vue"
import advertisingBannerDetail from "./mixins/advertisingBannerDetail";

export default {
  name: "AdvertisingBannerDetail",
  components: { BroadcastSearch, PreviewPopup },
  mixins: [detailActions, entity, advertisingBannerDetail],
  created(AdvertisingBannerService, DashboardCarouselService) {
    this.entityService = AdvertisingBannerService;
    this.dashboardCarouselService = DashboardCarouselService;
    this.createdInit().then(() =>{
    });
  },
  data(){
    return{
      moduleName: 'advertisingBanners',
      entityName: 'advertisingBanner',
      isUpdate: false,
      preview: false,
      previewData: {},
      broadcastNames: {},
    }
  },
  computed: {
    isEditable(){
      return this.entity.hasOwnProperty('processed_at')
          && !this.entity.processed_at
          && this.$_updateActionAllowed;
    }
  },
  methods: {
    _afterGetEntityActions() {
      this.searchBroadcastsById(this.entity.action_id);
    },
    searchBroadcastsById(ids) {
      if (!ids || ids.length === 0) {
        return;
      }
      this.dashboardCarouselService.searchBroadcastsByName({ ids: ids.join(',') }).then(response => {
        this.broadcastNames = {}
        response.data.forEach(item => {
          this.broadcastNames[item.id] = `${item.text}, ${item.datetime}`
        })
      })
    },
    updateAdvertisingBanner(){
      if(this.isRecipientsValid()) {
        this.submitForm()
      }else{
        this.setErrorMessage('Some recipients must be selected');
      }
    },
    showPreview: async function() {
      this.previewData = {
        ...(await this.$refs.advertisingBannerDetail.$refs.settingsRef.getPreviewData()),
        ...this.$refs.advertisingBannerDetail.$refs.messageRef.getPreviewData(),
      }
      this.preview = true
    },
    hidePreview() {
      this.preview = false
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingBanner/AdvertisingBannerDetail.vue